import { render, staticRenderFns } from "./LightBulbSection.vue?vue&type=template&id=8cc42b6e&"
import script from "./LightBulbSection.vue?vue&type=script&lang=js&"
export * from "./LightBulbSection.vue?vue&type=script&lang=js&"
import style0 from "./LightBulbSection.vue?vue&type=style&index=0&id=8cc42b6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports